import customTable from './customTable.vue'
export default customTable